<template>
  <div class="home uk-text-center">
    <div uk-grid class="uk-child-width-1-2@s uk-text-center uk-margin-medium-top">
      
      <div>
        <img alt="flag" style="max-width:350px" width="100%" 
        src="../assets/7c.png">
      </div>
      <div>
        <img alt="logo" src="../assets/logo.png" style="max-width:250px" width="70%">
      </div>
    </div>
    
    

    

    <h3 style="color:lightslategrey">PRECALIFICADOR Y MEDIDOR DE RIESGO CREDITICIO</h3>

    <p>Carga una soliciud del sistema de Solicitudes Online. También puedes ingresar los datos solicitados del solicitante o deudor dando click en Llenar Manualmente, elige su actividad económica principal, y presiona comenzar. También puedes subir un archivo csv con los datos del solicitante</p>


    <div uk-grid class="uk-child-width-1-1">
      <div>
        <router-link :to="'/load'" class="uk-button uk-button-primary uk-border-rounded" style="background-color: #6636cf">Cargar de solicitudes online</router-link>
      </div>
    </div>

    <div class="uk-child-width-1-2 uk-margin-large-bottom" uk-grid>
      <div >
            <div class="js-upload" uk-form-custom>
                <input type="file" id="file" accept=".csv" v-on:change="loadFromFile">
                <button class="uk-button uk-button-primary uk-button-large@m" type="button" tabindex="-1">subir archivo</button>
            </div>
      </div>
      <div >
                <button v-on:click="manual = !manual" class="uk-button uk-button-secondary uk-button-large@m" type="button"> <span v-if="manual">ocultar forma</span> <span v-else>llenar manualmente</span> </button>

      </div>
    </div>


    <div v-if="manual">



    <div class="uk-margin">
      <input type="text" class="uk-input" style="max-width:400px" v-model="name" placeholder="Nombre completo">
    </div>
       
    <div class="uk-margin uk-form-horizontal ">
    <div class="uk-margin uk-align-center"  style="max-width:550px" >
        <label class="uk-form-label" for="form-horizontal-text">Elije si es deudor, codeudor o aval</label>
        <div class="uk-form-controls">
        <select v-model="deudor" id="form-horizontal-text" class="uk-select">
          <option >Deudor</option>
          <option value="Codeudor" >Codeudor (esposa)</option>
          <option >Garante</option>
        </select>
        </div>
    </div>
    </div>
    

    <div class="uk-margin">
      <input type="text" class="uk-input" style="max-width:475px" v-model="rfc" placeholder="C.I. Cédula">
    </div>



    <div class="uk-margin uk-form-horizontal ">



       
    <div class="uk-margin uk-align-center"  style="max-width:550px" >
        <label class="uk-form-label" for="form-horizontal-text">Elije la actividad económica</label>
        <div class="uk-form-controls">
        <select v-model="act" id="form-horizontal-text" class="uk-select">
          <option >Agricultor / Ganadero</option>
          <option >Asaliariado empresa privado</option>
          <option >Asaliariado empresa pública</option>
          <option >Jubilado (recibe jubilación)</option>
          <option >Ama de casa</option>
          <option >Comerciante (compra y vende)</option>
          <option >Empresario</option>
          <option >Microempresario artesano (artesanías)</option>
          <option >Independiente (profesional)</option>
          <option >Oficios independientes (ej. albañil)</option>
        </select>
        </div>
    </div>

      
    </div>

    <a v-on:click="next" class="uk-button uk-button-large uk-button-primary">Comenzar</a>

    </div>


    <button v-on:click="clean" v-if="hasData" class="uk-button uk-button-large uk-button-secondary">Limpiar formas</button>



  </div>
</template>

<script>
export default {
  name: 'Home',
  data:function(){
    return {
      act:'',
      name:'',
      born:'',
      rfc:'',
      deudor : '',
      hasData : false,
      manual : false,
    }
  },
  methods:{
    loadFromFile:function(){
      // TODO load from file
      function onComplete(res, file){

        var data = res.data[0]

        this.$score['1C CARÁCTER O COMPORTAMIENTO OTRAS INSTITUCIONES'] = {
          'a - Cambios de domicilio':"",
          "b - Cambios de trabajo":"",
          'c - Calificaciones Buró de crédito':"",
          "d - Referencia respaldada con documento":"",
          "e - Calidad de referencias comerciales":"",
          "Bancos Saldo":data['DEUDAS FINANCIERAS '],
          "Bancos Pago":"",
          "Bancos Observaciones":"",
          "Coops Saldo":"",
          "Coops Pago":"",
          "Coops Observaciones":"",
          "Tiendas Saldo":"",
          "Tiendas Pago":"",
          "Tiendas Observaciones":"",
          "Tarjetas Saldo":data['DEUDAS POR TARJETA '],
          "Tarjetas Pago":data['GASTOS TARJETAS'],
          "Tarjetas Observaciones":"",
          "Propia Institución Saldo":"",
          "Propia Institución Pago":"",
          "Propia Institución Observaciones":"",
          "Otras Instituciones Saldo":data['CUENTAS POR PAGAR '],
          "Otras Instituciones Pago":"",
          "Otras Instituciones Observaciones":"",
        } 
        this.$score['2C CARÁCTER O COMPORTAMIENTO PROPIA INSTITUCIÓN FINANCIERA'] = {
          "a - Créditos pagados correctamente":"",
          "a - Monto máximo otorgado":"",
          "b - Antiguedad como socio o cliente en la sociedad financiera":"",
          "c - Ha tenido atrasos en el pago con la propia institución":"",
          "d - Ha confirmado telefónicamente la refencias personales":"",
          "e - Calificación otorgada por la institución ":"",
          "f - Análisis cualitativo por parte del asesor al socio o cliente":"",
          } 
        this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA'] = {
          "a - Actividad económica del cliente":"",
          "b - Destino del Crédito":"",
          "c - Años de experiencia en la actividad económica":"",
          "d - Estado civil de socio":"",
          "f - Edad del Socio":"",
          "g - Dependencia de los ingresos del socio":"",
          "h - Nivel de Educación":"",
          }
        this.$score['4C CAPACIDAD DE PAGO POR DATOS FINANCIEROS'] = {
          "Sueldo":data['INGRESOS POR SUELDOS'],
          "Retenciones":"",
          "Otros Ingresos":data['INGRESO POR PROPIEDADES'],
          "Ventas Por Periodo":data['INGRESOS POR NEGOCIO'],
          "Período de siembra-cosecha o venta":"",
          "Compras Mensuales":"",
          "Arriendos":data['GASTOS ARRIENDO'],
          "Pago empleados":"",
          "Pago servicios":"",
          "Pago deudas":"",
          "Dependientes":"",
          "Alimentación":"",
          "Vivienda":"",
          "Servicios":"",
          "Salud y educación":"",
          "Celular o internet":"",
          "Transporte":"",
          "Otros Gastos":data['OTROS GASTOS'],
          "Monto solicitado":data['MONTO SOLICITADO'],
          "Plazo":data['PLAZO EN MESES'],
          "Frecuencia Pago":"",
          "Tasa":15.99,
          "Porcentaje":"",
          } 
        this.$score['5C  CAPITAL O PATRIMONIO'] = {
          "a - Tipo de Vivienda":"",
          "a - Valor de la vivienda":"",
          } 
        this.$score['6C COLATERAL O GARANTÍAS'] = {
          "a - Requiere garantía líquida":"",
          "b - Cobertura":"",
          "b - Requiere aval personal":"",
          "b - Número de avales que presenta":"",
          "c - Requiere garantía o prenda":"",
          } 
        this.$score['7C CONDICIONES DEL MERCADO O ENTORNO'] = {
          "a - Situación económica del país":"",
          "b - Situación económica de la región donde está la actividad económica del solicitante":"",
          "c - Riesgo de la actividad económica del solicitante":"",
          "d - Inseguridad en el sector o localidad donde vive":"",
          } 
        // for(var j in this.$score){
        //   for(var i in this.$score[j]){
        //     if(data[i]){
        //       this.$score[j][i] = data[i]
        //     }
        //   }
        // }

        switch (String(data['Nombre del Socio']).toUpperCase()) {
          case 'CASADO':
            this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA']["d - Estado civil de socio"] = 7
            break;
          case 'UNIÓN LIBRE' :
            this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA']["d - Estado civil de socio"] = 6
            break;
          case 'UNION LIBRE' :
            this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA']["d - Estado civil de socio"] = 6
            break;
        
          default:
            this.$score['3C CAPACIDAD DE PAGO POR DATOS ACTIVIDAD ECONÓMICA']["d - Estado civil de socio"] = 3
            break;
        }
        switch (String(data['VIVIENDA']).toUpperCase()) {
          case 'RENTA':
            this.$score['5C  CAPITAL O PATRIMONIO']["a - Tipo de Vivienda"] = 3
            break;
          case 'RENTADA' :
            this.$score['5C  CAPITAL O PATRIMONIO']["a - Tipo de Vivienda"] = 3
            break;
        
          default:
            this.$score['5C  CAPITAL O PATRIMONIO']["a - Tipo de Vivienda"] = 7
            break;
        }


        this.$score.name = data['Nombre del Socio']
        // this.$score.asalariado = data['asalariado']
        

        UIkit.notification('Se cargaron todos los campos compatibles encontrados','success')
        sessionStorage.setItem('score',JSON.stringify(this.$score))
        this.$router.push('1c')
      }

      var file = document.getElementById('file').files[0]
      var config = {
	      header: true,
        // dynamicTyping: true,
        complete : onComplete.bind(this)
      }
      Papa.parse(file,config)



      UIkit.notification('No se encontraron campos compatibles en el archivo. <br> Llena las formas manualmente','warning')
      this.manual = true
    },
    clean:function(){
      sessionStorage.removeItem('score')
      location.reload()
    },
    next:function(){

      if(this.act){

        var asalariado

        switch (this.act) {
          case 'Asaliariado empresa privado':
            asalariado = true
            break;
          case 'Asaliariado empresa pública':
            asalariado = true
            break;
          case 'Jubilado (recibe jubilación)':
            asalariado = true
            break;
          case 'Ama de casa':
            asalariado = true
            break;
          case 'Comerciante (compra y vende)':
            asalariado = false
            break;
          case 'Empresario':
            asalariado = false
            break;
          case 'Microempresario artesano (artesanías)':
            asalariado = false
            break;
          case 'Independiente (profesional)':
            asalariado = false
            break;
          case 'Oficios independientes (ej. albañil)':
            asalariado = false
            break;
          case 'Agricultor / Ganadero':
            asalariado = false
            break;
        
          default:
            break;
        }

        this.$score.asalariado = asalariado

        this.$score.name = this.name

        this.$score.act = this.act
        this.$score.deudor = this.deudor
        // this.$score['Fecha de nacimiento'] = this.born
        this.$score['Cédula'] = this.rfc

        sessionStorage.setItem('score',JSON.stringify(this.$score))
        this.$router.push('1c')
    
      } else {
        UIkit.notification('Debes elegir una actividad','warning')
      }

    }
  },
  mounted : function() {
    if(sessionStorage.getItem('score')){
      this.$score = JSON.parse(sessionStorage.getItem('score'))
      this.hasData = true

         this.name = this.$score.name

       this.act  = this.$score.act
       this.born = this.$score['Fecha de nacimiento'] 
         this.rfc = this.$score['Cédula']
       this.deudor =  this.$score.deudor
      
    } 

  }
}
</script>
